import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DashboardService {
  private schemeType =  new BehaviorSubject<any>(null);

  constructor(private base: BaseService) { }

  setScheme(tab: any) {
    this.schemeType.next(tab);
  }

  getScheme(): Observable<any>  {
    return this.schemeType.asObservable()
  }
  
  totalCount(){
    return  this.base.get('/api/get-all-total-count');
    // return  this.base.get('/api/get-all-total-count-v1');
  }

  totalCountV1(){
    return  this.base.get('/api/get-all-total-count-v1');
  }

  getChartData(){
    return  this.base.get('/api/get-chart-data');
  }

  sumAllData(){
    return this.base.get('/api/get-all-dashboard-data');
  }

  getLastProduct(){
    return this.base.get('/api/get-latestProduct');
  }

  filterByDate(data){
    return this.base.post('/api/filter-by-date-user-by-state',data);
  }

}
